import React from "react";
import {aybMenuService} from "../../jwt/_services/ayb/aybMenuService";

export const aybMenuProvider = {
    getOptions,
    getItem,
};

async function getOptions(customFilter) {
    try {
        const listItems = await aybMenuService.search(0, 10000, customFilter );
        listItems.data.sort((a, b) => a.title.localeCompare(b.title));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.title,
                    label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.title }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await aybMenuService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}